/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import { KTIcon } from '../../../helpers';
import { useNavigate } from 'react-router-dom';
import { useQuery } from 'react-query';
import { get_all_inactive_applications } from '../../../../app/pages/users-applications/api/applicationsApi';
import moment from 'moment';
import { permissionCheck } from '../../../../app/helper-functions/PermissionCheck';

type Props = {
    className: string;
};
var user_application_view;
const TablesWidget6: React.FC<Props> = ({ className }) => {
    const [inactiveApplications, setInactiveApplications] = useState<any[]>([]);
    const navigate = useNavigate();
    const [hoveredCard, setHoveredCard] = useState(null);
    user_application_view = permissionCheck('user-application-view');
    const { data, isLoading, isError } = useQuery(
        'get_all_inactive_applications',
        get_all_inactive_applications,
        { refetchOnWindowFocus: false }
    );

    useEffect(() => {
        if (data) {
            const applicationsArray: any[] = Object.values(data.data).sort(
                (a: any, b: any) => {
                    const dateA = a.updated_at ? new Date(a.updated_at) : new Date(0);
                    const dateB = b.updated_at ? new Date(b.updated_at) : new Date(0);
                    return dateA.getTime() - dateB.getTime();
                }
            );
            const oldestSix = applicationsArray.slice(0, 6); // Get the oldest 6
            setInactiveApplications(oldestSix);
        }
    }, [data]);

    const handleViewApplication = (application: any) => {
        navigate('/user-applications/view-application-details', {
            state: { application: application },
        });
    };

    const handleViewAll = () => {
        // Navigate to a page that lists all inactive applications.
        navigate('/user-applications/inactive');
    };

    const handleMouseEnter = (applicationId) => {
        setHoveredCard(applicationId);
    };

    const handleMouseLeave = () => {
        setHoveredCard(null);
    };

    return (
        <div className={`card ${className}`}>
            <div className='card-header border-0 pt-5'>
                <h3 className='card-title align-items-start flex-column'>
                    <span className='card-label fw-bolder fs-3 mb-1'>
                        Oldest Inactive Applications
                    </span>
                    <span className='text-muted mt-1 fw-semibold fs-7'>
                        List of the {inactiveApplications.length} oldest inactive user applications.
                    </span>
                </h3>
            </div>

            <div className='card-body py-3'>
                <div className='row g-5 g-xl-8'>
                    {inactiveApplications.length > 0 ? (
                        inactiveApplications.map((application) => (
                          <div key={application.id} className='col-xl-4 col-md-6'>
                            <div className={`card card-shadow h-xl-100 card-hover`}>
                              <div className='card-body d-flex flex-column justify-content-between p-5'>
                                <div>
                                  <a
                                    href="#"
                                    onClick={(e) => {
                                      if (!user_application_view) return; // Prevent navigation if no permission
                                      e.preventDefault();
                                      handleViewApplication(application);
                                    }}
                                    onMouseEnter={() => handleMouseEnter(application.id)}
                                    onMouseLeave={handleMouseLeave}
                                    className={`card-title fw-bold mb-2 ${user_application_view ? 'title-clickable' : 'title-disabled'}`}
                                  >
                                    {application.application_name}
                                  </a>

                                  <p className='card-text text-muted'>
                                                Organization: {application.organization_name}
                                            </p>
                                            <p className='card-text text-muted'>
                                                Last Updated: {application.updated_at
                                                    ? moment(application.updated_at).format('DD-MM-YYYY HH:mm')
                                                    : 'Never'}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className='text-center'>
                            <p className='text-muted'>No inactive applications found.</p>
                        </div>
                    )}
                </div>
            </div>

            {/* View All Button */}
            {inactiveApplications.length > 0 && (
                <div className='card-footer d-flex justify-content-end py-3'>
                    <button className='btn btn-light-primary' onClick={handleViewAll}>
                        View All
                    </button>
                </div>
            )}
        </div>
    );
};

export { TablesWidget6 };